import React from 'react'

import Relazsizes from 'relazsizes'

import Typography from 'components/atoms/Typography'
import config from 'config'

const { assets_url: assetsUrl } = config

const EmptyNotification = () => (
  <div className="empty-notification">
    <div className="empty-notification__wrapper">
      <div className="empty-notification__img">
        <Relazsizes
          dataSrc={`${assetsUrl}/assets/img/empty_notification.svg`}
          alt="Empty Notification"
        />
      </div>
      <Typography variant="subbody" component="h6" fontWeight="bold" className="empty-notification__title">
        Tidak ada notifikasi baru
      </Typography>
      <Typography variant="caption" component="div" className="empty-notification__subtitle">
        Semua pemberitahuan terkait Quipper Campus dapat kamu temukan di sini.
      </Typography>
    </div>
    <style jsx global>
      {`
        .empty-notification {
          &__wrapper {
            padding: 100px 24px 0;
            text-align: center;
          }
          &__title {
            margin: 16px 0 8px !important;
            color: #0c2846 !important;
          }
          &__subtitle {
            color: #0c2846 !important;
          }
          &__img {
            width: 200px;
            height: 125px;
            margin: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              height: 90px;
            }
          }
          @media screen and (min-width: 768px) {
            &__wrapper {
              padding: 44px 40px;
            }
            &__img {
              height: 100px;
            }
          }
        }
      `}
    </style>
  </div>
)

export default EmptyNotification
